/* Jalecos Mania — conteúdo do cart drawer (mini-sacola).
   A casca (abrir/fechar/overlay/foco) e o auto-open no add são do Horizon nativo
   (<theme-drawer> + <cart-drawer-component auto-open>). Aqui só cuidamos do conteúdo:
   remover item e recalcular tudo via /cart/change.js + Section Rendering, consulta de
   CEP (mensagem) e refresh do corpo quando um produto é adicionado. Leve de propósito. */
(function () {
  var SECTION_ID = 'cart-drawer-section';
  var BODY_SELECTOR = '[data-jm-drawer-body]';

  function drawer() {
    return document.querySelector('[data-jm-drawer]');
  }

  function swapBody(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(BODY_SELECTOR);
    var current = document.querySelector(BODY_SELECTOR);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function setLoading(on) {
    var root = drawer();
    if (root) root.classList.toggle('jm-cd--loading', !!on);
  }

  function updateCount(count) {
    if (count == null) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  // Remove a peça e todos os bordados vinculados em uma única operação.
  function removeItem(button) {
    setLoading(true);
    var groups = window.JMCartGroups;
    var request = groups && groups.change ? groups.change({
      line: button.getAttribute('data-line'),
      key: button.getAttribute('data-key'),
      quantity: 0,
      sectionId: SECTION_ID,
      sectionsUrl: '/',
    }) : fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(button.getAttribute('data-line')), quantity: 0, sections: SECTION_ID, sections_url: '/' }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart-line-update-failed');
      return response.json();
    });

    request
      .then(function (data) {
        updateCount(groups && groups.visibleCount ? groups.visibleCount(data) : data.item_count);
        var html = data.sections && data.sections[SECTION_ID];
        if (html) {
          swapBody(html);
        } else {
          refresh(); // fallback: se a section não veio, busca de novo
        }
      })
      .catch(function () { refresh(); })
      .finally(function () { setLoading(false); });
  }

  // refresh do corpo quando o carrinho muda por fora (ex.: add pela vitrine).
  // Se o evento já trouxe a section renderizada (event.detail.sections), usa ela
  // e evita um request; senão, busca via Section Rendering.
  function refresh(event) {
    if (!drawer()) return;
    var fromEvent = event && event.detail && event.detail.sections && event.detail.sections[SECTION_ID];
    if (fromEvent) {
      swapBody(fromEvent);
      return;
    }
    // raiz de propósito: em /collections/* o Shopify responde 404 para ?sections=
    fetch('/?sections=' + SECTION_ID, {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) { return r.json(); })
      .then(function (data) { swapBody(data[SECTION_ID]); })
      .catch(function () {});
  }

  // delegação em fase de CAPTURA (roda antes de qualquer stopPropagation nativo)
  // e sobrevive às trocas de innerHTML do corpo.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var remove = target.closest('[data-jm-remove]');
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      if (remove.getAttribute('data-line')) removeItem(remove);
    }
  }, true);

  function jmQuoteFrete(cep, itemCount, declaredCents, weightGrams, items, done) {
    var base = window.JM_FRETE_ENDPOINT || 'https://checkout.jalecosmania.com.br';
    var promotionToken = '';
    try { promotionToken = new URLSearchParams(window.location.search).get('jm_promo') || window.sessionStorage.getItem('jm_promo') || ''; } catch (_) { /* optional campaign token */ }
    fetch(base + '/api/shipping/quote', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cep: cep, itemCount: itemCount || 1, declaredCents: declaredCents || 0, weightGrams: weightGrams || 0, items: items || [], promotionToken: promotionToken })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { done(data && data.configured && data.quotes && data.quotes.length ? data.quotes : null); })
      .catch(function () { done(null); });
  }
  function jmRenderQuotes(out, quotes) {
    out.textContent = '';
    quotes.forEach(function (q) {
      var line = document.createElement('div');
      var name = document.createElement('span');
      name.textContent = (q.name || (q.carrierLabel + ' ' + q.label)) + ' — ';
      var price = document.createElement('b');
      price.textContent = 'R$ ' + (q.priceCents / 100).toFixed(2).replace('.', ',');
      var term = document.createElement('span');
      term.textContent = ' · ' + q.durationLabel;
      line.appendChild(name); line.appendChild(price); line.appendChild(term);
      out.appendChild(line);
    });
  }
  var jmQuoteTicket = 0;
  var jmLastCep = '';
  function jmQuoteFromCart(cep, msg, fallbackText) {
    var mine = ++jmQuoteTicket;
    jmLastCep = cep;
    msg.textContent = 'Calculando frete…';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (item) { return { productId: item.product_id, variantId: item.variant_id, quantity: item.quantity || 1 }; });
        jmQuoteFrete(cep, Math.max(1, cart.item_count || 1), cart.total_price || 0, cart.total_weight || 0, items, function (quotes) {
          if (mine !== jmQuoteTicket) return; // resposta velha: ignora
          if (quotes) jmRenderQuotes(msg, quotes);
          else msg.textContent = fallbackText;
        });
      })
      .catch(function () { if (mine === jmQuoteTicket) msg.textContent = fallbackText; });
  }
  // Cotação automática: dispara sozinha quando o CEP fica completo (debounce).
  var jmCepTimer = null;
  document.addEventListener('input', function (event) {
    var input = event.target;
    var form = input && input.closest && input.closest('[data-jm-shipping]');
    if (!form) return;
    var msg = form.querySelector('[data-jm-shipping-msg]');
    if (!msg) return;
    var cep = (input.value || '').replace(/\D/g, '');
    if (jmCepTimer) clearTimeout(jmCepTimer);
    if (cep.length !== 8 || cep === jmLastCep) return;
    jmCepTimer = setTimeout(function () {
      jmQuoteFromCart(cep, msg, 'Entrega estimada em 4 a 7 dias úteis. Frete grátis quando a meta for atingida.');
    }, 350);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-jm-shipping]');
    if (!form) return;
    event.preventDefault();
    var input = form.querySelector('input');
    var msg = form.querySelector('[data-jm-shipping-msg]');
    var cep = (input && input.value || '').replace(/\D/g, '');
    if (!msg) return;
    if (cep.length < 8) { msg.textContent = 'Digite um CEP válido.'; return; }
    jmQuoteFromCart(cep, msg, 'Entrega estimada em 4 a 7 dias úteis. Frete grátis quando a meta for atingida.');
  }, true);

  // quando um produto é adicionado (vitrine dispara o evento nativo), o drawer
  // auto-abre e nós atualizamos o conteúdo para mostrar o item recém-adicionado
  document.addEventListener('shopify:cart:lines-update', refresh);

  // fechar clicando fora (no fundo escurecido), igual ao site base
  document.addEventListener('click', function (event) {
    var td = document.getElementById('cart-drawer');
    if (!td) return;
    var dialog = td.querySelector('dialog');
    if (!dialog || !dialog.open) return;
    // clique no ::backdrop de um dialog modal chega com target = o próprio dialog
    var onBackdrop = event.target === dialog;
    var inside = !onBackdrop && event.target.closest && event.target.closest('#cart-drawer');
    var onTrigger = event.target.closest && event.target.closest('[aria-controls="cart-drawer"]');
    if (onBackdrop || (!inside && !onTrigger)) {
      if (typeof td.close === 'function') td.close();
    }
  });

  // watchdog: se a animação de fechar travar (fica presa em 0ms), finaliza na mão.
  // Vale pra QUALQUER fechamento (X, clique fora, Esc).
  (function () {
    var td = document.getElementById('cart-drawer');
    if (!td) return;
    new MutationObserver(function () {
      var dialog = td.querySelector('dialog');
      if (!dialog || td.hasAttribute('open') || !dialog.open) return;
      // fechamento em andamento: dá um empurrão se a animação não avançar
      window.setTimeout(function () {
        if (!dialog.open || td.hasAttribute('open')) return;
        dialog.getAnimations().forEach(function (a) {
          if (a.playState === 'running' && (a.currentTime === 0 || a.currentTime === null)) {
            try { a.finish(); } catch (e) {}
          }
        });
        // última garantia: fecha direto se ainda estiver aberto
        window.setTimeout(function () {
          if (dialog.open && !td.hasAttribute('open')) {
            dialog.classList.remove('theme-drawer__dialog--closing');
            dialog.close();
          }
        }, 250);
      }, 200);
    }).observe(td, { attributes: true, attributeFilter: ['open'] });
  })();
})();
